<template>
  <section id="o-nas" class="bg-white py-20 sm:py-28">
    <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div class="grid grid-cols-1 gap-16 lg:grid-cols-2 lg:items-center">
        <div>
          <span class="section-label">O nas</span>
          <h2 class="section-title">
            Precyzja, doświadczenie i pełna kompleksowość realizacji
          </h2>
          <p class="mt-6 text-base leading-relaxed text-graphite-600">
            Monteco to zespół specjalistów w obróbce metalu, który łączy dokładność projektową
            z rzemieślniczą precyzją wykonania. Prowadzimy zlecenia od pierwszego szkicu CAD,
            przez cięcie i formowanie, aż po finalne wykończenie powierzchni — bez angażowania
            kolejnych podwykonawców po Twojej stronie.
          </p>
          <p class="mt-4 text-base leading-relaxed text-graphite-600">
            Dzięki własnemu parkowi maszynowemu i doświadczonym pracownikom kontrolujemy jakość
            na każdym etapie produkcji, co przekłada się na powtarzalność i terminowość dostaw —
            kluczowe dla naszych klientów przemysłowych.
          </p>

          <div class="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-3">
            <div v-for="item in pillars" :key="item.title">
              <div class="flex h-11 w-11 items-center justify-center rounded-sm border-2 border-brand-600 text-brand-600">
                <span v-html="item.icon"></span>
              </div>
              <h3 class="mt-4 text-sm font-bold text-graphite-900">{{ item.title }}</h3>
              <p class="mt-1.5 text-sm leading-relaxed text-graphite-500">{{ item.text }}</p>
            </div>
          </div>
        </div>

        <div class="relative">
          <div class="aspect-[4/5] w-full bg-graphite-900 p-8">
            <div class="relative h-full w-full border border-white/15">
              <span class="absolute -left-px -top-px h-6 w-6 border-l-2 border-t-2 border-brand-500"></span>
              <span class="absolute -right-px -top-px h-6 w-6 border-r-2 border-t-2 border-brand-500"></span>
              <span class="absolute -bottom-px -left-px h-6 w-6 border-b-2 border-l-2 border-brand-500"></span>
              <span class="absolute -bottom-px -right-px h-6 w-6 border-b-2 border-r-2 border-brand-500"></span>

              <div class="flex h-full w-full flex-col items-center justify-center gap-6 px-8">
                <svg viewBox="0 0 160 100" class="h-auto w-2/3 text-white/25" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M10 80V30l40-20h60l40 20v50" stroke-linejoin="round" />
                  <path d="M10 80h140M50 10v20M110 10v20" stroke-dasharray="4 4" />
                </svg>
                <div class="flex items-center gap-2 text-white/40">
                  <span class="h-px w-10 bg-white/25"></span>
                  <span class="text-[11px] font-bold uppercase tracking-[0.2em]">Dokumentacja CAD</span>
                  <span class="h-px w-10 bg-white/25"></span>
                </div>
              </div>
            </div>
          </div>
          <div class="absolute -bottom-6 -left-6 hidden border-2 border-brand-600 bg-white p-6 sm:block">
            <p class="text-3xl font-black text-brand-700">100%</p>
            <p class="mt-1 text-xs font-semibold uppercase tracking-wider text-graphite-500">
              kontroli na każdym<br />etapie produkcji
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AboutSection',
  data() {
    return {
      pillars: [
        {
          title: 'Precyzja',
          text: 'Dokładność wymiarowa i kontrola jakości na każdym etapie produkcji.',
          icon: '<svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>'
        },
        {
          title: 'Doświadczenie',
          text: 'Lata praktyki w obróbce metalu dla klientów przemysłowych i produkcyjnych.',
          icon: '<svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>'
        },
        {
          title: 'Kompleksowość',
          text: 'Od projektu, przez produkcję, po wykończenie — wszystko pod jednym dachem.',
          icon: '<svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"/></svg>'
        }
      ]
    };
  }
};
</script>
